import React, { useState, useEffect } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import BoxWrapper from "../../components/ui/boxWrapper";
import "./mdm.css";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import axios from "../../axios-order";
import moment from "moment";
import { toast } from "react-toastify";
import { TablePagination } from "@material-ui/core";

const Mdm = () => {
  const [mdmType, setMdmType] = useState("CUSTOMER");
  const [tableData, setTableData] = useState([]);
  const [mutiSelector, setMutiSelector] = useState([]);

  const [tableForRadio, setTableForRadio] = useState([]);
  const [triggerTable, setTriggerTable] = useState(false);

  const [tableCheckBoxSelector, setTableCheckBoxSelector] = useState([]);
  const [isCheck, setIsCheck] = useState([]);

  // Add persistent selection state
  const [persistentSelectedItems, setPersistentSelectedItems] = useState(new Set());

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [rowCount, setRowCount] = useState(0);

  const [triggerPage, setTriggerPage] = useState(false);
  const [triggerRowPerPage, setTriggerRowPerPage] = useState(false);

  const [textsearch, setTextsearch] = useState("");

  const [selectAllCheck, setSelectAllCheck] = useState(false);
  const [entireAllCheck, setEntireAllCheck] = useState(false);

  const [searchString, setSearchString] = useState('');

  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState(null);

  const [mdmData, setMdmData] = useState(null);
  const [mdmDataLoading, setMdmDataLoading] = useState(true);

  // Function to get available filters (only those with value 1)
  const getAvailableFilters = () => {
    if (!mdmData) return [];

    const filters = [];
    if (mdmData.gstin === 1) filters.push({ value: "GSTIN", label: "GSTIN" });
    if (mdmData.pan === 1) filters.push({ value: "PAN", label: "PAN" });
    if (mdmData.tan === 1) filters.push({ value: "TAN", label: "TAN" });
    if (mdmData.msme === 1) filters.push({ value: "MSME", label: "MSME" });
    if (mdmData.cin_lpin === 1) filters.push({ value: "CIN/LPIN", label: "CIN/LPIN" });

    return filters;
  };

  // Check if all filters are disabled (all values are 0)
  const areAllFiltersDisabled = () => {
    if (!mdmData) return false;
    return mdmData.gstin === 0 && mdmData.pan === 0 && mdmData.msme === 0 && mdmData.cin_lpin === 0;
  };

  //Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setSelectAllCheck(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchString(event.target.value);
    setPage(0);
  };

  const mdmList = () => {
    setMdmDataLoading(true);
    axios
      .get(`/get_mdm_filters_service/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        setMdmData(res.data);
        setMdmDataLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    let timer = setTimeout(() => {
      getApiForRadio(textsearch);
    }, 300);

    return () => clearTimeout(timer)
  }, [textsearch])

  useEffect(() => {
    if (triggerPage) {
      getApiForRadio("");
    }
    setTriggerPage(false);
  }, [triggerPage]);

  useEffect(() => {
    if (triggerRowPerPage === true) {
      getApiForRadio("");
    }
    setTriggerRowPerPage(false);
  }, [triggerRowPerPage]);

  const mdmChangeHandler = (e) => {
    const { value } = e.target;
    setSelectAllCheck(false);
    setMdmType(value);

    setPage(0);
    setRowsPerPage(25);
    setRowCount(0);
    setTableCheckBoxSelector([]);
    // Clear persistent selections when MDM type changes
    setPersistentSelectedItems(new Set());
  };

  const handleChange = (event, value) => {
    if (event.target.checked) {
      setMutiSelector(prev => [...prev, value]);
    } else {
      setMutiSelector(prev => prev.filter(item => item !== value));
    }
  };

  // const handleChange = (event, value) => {
  //   if (event.target.checked) {
  //     setMutiSelector((pev) => pev.concat(value));
  //   } else {
  //     const index = mutiSelector.findIndex((item) => item === value);
  //     mutiSelector.splice(index, 1);
  //   }
  // };

  useEffect(() => {
    console.log(tableCheckBoxSelector, 'tableCheckBoxSelector.....')
  }, [tableCheckBoxSelector])

  // Modified tableCheckBox function with persistent selection
  const tableCheckBox = (event, uniqueKey) => {
    const onChecked = event.target.checked;
    const newPersistentSelected = new Set(persistentSelectedItems);

    if (onChecked) {
      setTableCheckBoxSelector((prev) => [...prev, uniqueKey]);
      newPersistentSelected.add(uniqueKey);
    } else {
      setTableCheckBoxSelector((prev) => prev.filter((id) => id !== uniqueKey));
      newPersistentSelected.delete(uniqueKey);
    }

    setPersistentSelectedItems(newPersistentSelected);
  };

  const mdmFormSubmitHandler = () => {
    if (mdmType === '' || mutiSelector.length === 0) {
      toast.error('Please select any one MDM type and Any One filter Type', {
        autoClose: 3000,
        progress: 0,
      });
    } else {
      const selectedIds = Array.from(persistentSelectedItems);
      const selectedCount = entireAllCheck ? rowCount : selectedIds.length;

      // Store data and show dialog
      setPendingSubmitData({
        selectedIds,
        selectedCount,
        isSelectAll: entireAllCheck
      });
      setShowConfirmDialog(true);
    }
  };

  const handleConfirmSubmit = () => {
    const { selectedIds, isSelectAll } = pendingSubmitData;

    axios
      .post('/mdm_karza_recon/report', {
        karza_apis_selected: mutiSelector,
        business_entity_id: localStorage.getItem('business_entity_id'),
        cust_type: mdmType,
        selected_ids: isSelectAll ? [] : selectedIds,
        is_all_data: isSelectAll ? true : false,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(res?.data?.message, {
            autoClose: 3000,
            progress: 0,
          });
          setMutiSelector([]);
          getApiForRadio();
          setEntireAllCheck(false);
          setSelectAllCheck(false);
          setTableCheckBoxSelector([]);
          setPersistentSelectedItems(new Set());
        }
        else {
          toast.error(res?.data?.message, {
            autoClose: 3000,
            progress: 0,
          });
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message || 'Error submitting data', {
          autoClose: 3000,
          progress: 0,
        });
      })
      .finally(() => {
        setShowConfirmDialog(false);
        setPendingSubmitData(null);
      });
  };

  // Modified form submit handler to use persistent selections
  // const mdmFormSubmitHandler = () => {
  //     if (mdmType === '' || mutiSelector.length === 0) {
  //       toast.error('Please select any one MDM type and Any One filter Type', {
  //         autoClose: 3000,
  //         progress: 0,
  //       });
  //     } else {
  //       const selectedIds = Array.from(persistentSelectedItems);
  //       const selectedCount = entireAllCheck ? rowCount : selectedIds.length;

  //       const confirmMessage = entireAllCheck
  //         ? `You are about to process ALL ${selectedCount} records. Do you want to continue?`
  //         : `You have selected ${selectedCount} record(s). Do you want to continue?`;

  //       if (!window.confirm(confirmMessage)) {
  //         return;
  //       }

  //       axios
  //         .post('/mdm_karza_recon/report', {
  //           karza_apis_selected: mutiSelector,
  //           business_entity_id: localStorage.getItem('business_entity_id'),
  //           cust_type: mdmType,
  //           selected_ids: entireAllCheck ? [] : selectedIds,
  //           is_all_data: entireAllCheck ? true : false,
  //         })
  //         .then((res) => {
  //           if (res?.data?.status === true) {
  //             toast.success(res?.data?.message, {
  //               autoClose: 3000,
  //               progress: 0,
  //             });
  //             setMutiSelector([]);
  //             getApiForRadio();
  //             setEntireAllCheck(false); // Reset button to "Select All"
  //             setSelectAllCheck(false);
  //             setTableCheckBoxSelector([]);
  //             setPersistentSelectedItems(new Set());
  //           }
  //           else {
  //             toast.error(res?.data?.message, {
  //               autoClose: 3000,
  //               progress: 0,
  //             });
  //           }
  //         })
  //         .catch((e) => {
  //           toast.error(e?.response?.data?.message || 'Error submitting data', {
  //             autoClose: 3000,
  //             progress: 0,
  //           });
  //         });
  //     }
  //   };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  const downloadExcelSheet = (mdm_logs, cust, id) => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `MDM Recon Summary`;

    axios
      .post(`/mdm_karza_recon/extract`, {
        data: mdm_logs,
        cust_type: cust,
        business_entity_id: localStorage.getItem("business_entity_id"),
        log_id: id
      })
      .then((res) => {
        if (res?.data?.status === "pass") {
          downloadBase64File(contentType, res.data.file, filename);
        } else {
          alert("Unable To Download Excel");
        }
      });
  };

  const downloadMDMHandler = (id, cust_type) => {
    axios.get(`/mdm_karza_recon_json_log/${id}`).then((res) => {
      if (res?.data?.status === true) {
        if (res?.data?.record?.status === "Fail") {
          alert(res?.data?.record?.error);
        } else if (res?.data?.record?.status === "Pass") {
          downloadExcelSheet(res?.data?.record?.mdm_log, cust_type, id);
        }
      } else {
        alert("Unable To Download Please Try Again");
      }
    }).catch = (e) => {
      alert("Unable To Download Please Try Again");
    };
  };

  const getApi = () => {
    axios
      .get(`/mdm_karza_log/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        if (res.data.status === true) {
          setTableData(res?.data?.record);
        } else {
          setTableData([]);
        }
      }).catch = (e) => {
        // setTableData([]);
        // alert(e.response.data.message);
      };
  };

  // Modified getApiForRadio to maintain persistent selections
  const getApiForRadio = (searchVal = searchString) => {
    setTriggerTable(true);
    setTableForRadio([]);
    axios
      .post(`/get_mdm_master_data`, {
        bid: localStorage.getItem('business_entity_id'),
        cust_type: mdmType,
        filt_val: searchVal,
        pg_sz: rowsPerPage,
        pg_no: page,
      })
      .then((res) => {
        if (res.data.status === true) {
          setTableForRadio(res?.data?.records);
          setRowCount(res?.data?.row_count);
          setTriggerTable(false);

          // Update current page selection state based on persistent selections
          const currentPageSelectedIds = res?.data?.records
            .filter(item => persistentSelectedItems.has(item.unique_key))
            .map(item => item.unique_key);
          setTableCheckBoxSelector(currentPageSelectedIds);
        } else {
          setTriggerTable(false);
        }
      })
      .catch((e) => {
        toast.error(e?.response?.data?.message || 'Error fetching data', {
          autoClose: 3000,
          progress: 0,
        });
        setTriggerTable(false);
      });
  };


  useEffect(() => {
    if (mdmType) {
      getApiForRadio();
    }
  }, [page, rowsPerPage, searchString, mdmType]);

  useEffect(() => {
    getApi();
    mdmList();
  }, []);

  // Modified isChecked to use persistent selections
  const isChecked = (uniqueKey) => {
    return persistentSelectedItems.has(uniqueKey);
  };

  // Modified selectAllItems function
  const selectAllItems = () => {
    const newPersistentSelected = new Set(persistentSelectedItems);

    if (!selectAllCheck) {
      const allIds = tableForRadio.map((item) => item.unique_key);
      allIds.forEach(id => newPersistentSelected.add(id));
      setTableCheckBoxSelector((prev) => [
        ...new Set([...prev, ...allIds]), // Avoid duplicates
      ]);
    } else {
      const currentPageIds = tableForRadio.map((item) => item.unique_key);
      currentPageIds.forEach(id => newPersistentSelected.delete(id));
      setTableCheckBoxSelector((prev) =>
        prev.filter((id) => !currentPageIds.includes(id))
      );
    }

    setPersistentSelectedItems(newPersistentSelected);
  };

  useEffect(() => {
    if (selectAllCheck) {
      setTableCheckBoxSelector(tableForRadio.map(each => each.unique_key));
    } else {
      setTableCheckBoxSelector([]);
    }
  }, [selectAllCheck, tableForRadio]);

  return (
    <>
      <FormControl>
        <RadioGroup
          row
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="mdmType"
          value={mdmType ?? ""}
          onChange={mdmChangeHandler}
        >
          <FormControlLabel
            value="CUSTOMER"
            control={<Radio />}
            label="Customers MDM"
          />
          <FormControlLabel
            value="VENDOR"
            control={<Radio />}
            label="Vendors MDM"
          />
        </RadioGroup>
      </FormControl>

      {showConfirmDialog && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#333' }}>
              Confirm Submission
            </h3>
            <p style={{ marginBottom: '25px', color: '#666', lineHeight: '1.5' }}>
              {pendingSubmitData?.isSelectAll
                ? `You are about to process ALL ${pendingSubmitData?.selectedCount} records.`
                : `You have selected ${pendingSubmitData?.selectedCount} record(s).`}
              <br />
              Do you want to continue?
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowConfirmDialog(false);
                  setPendingSubmitData(null);
                }}
                style={{
                  padding: '8px 20px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmSubmit}
                style={{
                  padding: '8px 20px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* <BoxWrapper
        boxTitle={`${mdmType === 'CUSTOMER' ? 'CUSTOMER MDM' : 'VENDOR MDM'}`}
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel={!selectAllCheck ? 'Select All' : 'Deselect All'}
        buttonWidth="110px"
        addButtonHandlerFn={() => {
          selectAllItems();
          setSelectAllCheck(!selectAllCheck);
        }}
      >
      
        {persistentSelectedItems.size > 0 && (
          <div style={{ marginBottom: '10px' }}>
            <button 
              onClick={() => {
                setPersistentSelectedItems(new Set());
                setTableCheckBoxSelector([]);
                setSelectAllCheck(false);
              }}
              style={{ 
                background: '#dc3545', 
                color: 'white', 
                border: 'none', 
                padding: '5px 10px', 
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
            >
              Clear All Selections ({persistentSelectedItems.size})
            </button>
          </div>
        )}
        
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>{mdmType === 'CUSTOMER' ? 'Customer Name' : 'Vendor Name'}</th>
                <th>GSTIN</th>
                <th>PAN</th>
                <th>Created date</th>
                <th>Modified Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {mdmType === 'CUSTOMER' ? (
                <>
                  {triggerTable === true && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        Loading Please Wait!
                      </td>
                    </tr>
                  )}
                  {tableForRadio?.length > 0 &&
                    tableForRadio.map((values, i) => (
                      <tr key={i}>
                        <td>{values?.cust_legal_name}</td>
                        <td>{values?.cust_gstin}</td>
                        <td>{values?.cust_pan}</td>
                        <td>{values?.create_date}</td>
                        <td>{values?.modify_date}</td>
                        <td>
                          <Checkbox
                            checked={isChecked(values.unique_key)}
                            onChange={(e) => tableCheckBox(e, values.unique_key)}
                          />
                        </td>
                      </tr>
                    ))}
                  {tableForRadio?.length === 0 && !triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                <>
                  {triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        Loading Please Wait!
                      </td>
                    </tr>
                  )}
                  {tableForRadio?.length > 0 &&
                    tableForRadio.map((values, i) => (
                      <tr key={i}>
                        <td>{values?.vendor_name}</td>
                        <td>{values?.vendor_gstin}</td>
                        <td>{values?.vendor_pan}</td>
                        <td>{values?.create_date}</td>
                        <td>{values?.modify_date}</td>
                        <td>
                          <Checkbox
                            checked={isChecked(values.unique_key)}
                            onChange={(e) => tableCheckBox(e, values.unique_key)}
                          />
                        </td>
                      </tr>
                    ))}
                  {tableForRadio?.length === 0 && !triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <TablePagination
          rowsPerPageOptions={[25, 100, 500, 1000]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </BoxWrapper> */}

      <BoxWrapper
        boxTitle={`${mdmType === 'CUSTOMER' ? 'CUSTOMER MDM' : 'VENDOR MDM'}`}
        enableSearchInput={true}
        searchInputPlaceholder="Search..."
        searchInputOnchange={handleSearch}
        enableAddButton={true}
        addButtonLabel={!entireAllCheck ? 'Select All' : 'Deselect All'}
        buttonWidth="110px"
        addButtonHandlerFn={() => {
          setEntireAllCheck(!entireAllCheck);
        }}
      >
        {/* Add clear all selections button if there are persistent selections */}
        {persistentSelectedItems.size > 0 && !entireAllCheck && (
          <div style={{ marginBottom: '10px' }}>
            <button
              onClick={() => {
                setPersistentSelectedItems(new Set());
                setTableCheckBoxSelector([]);
                setSelectAllCheck(false);
              }}
              style={{
                background: '#dc3545',
                color: 'white',
                border: 'none',
                padding: '5px 10px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px'
              }}
            >
              Clear All Selections ({persistentSelectedItems.size})
            </button>
          </div>
        )}

        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>{mdmType === 'CUSTOMER' ? 'Customer Name' : 'Vendor Name'}</th>
                <th>GSTIN</th>
                <th>PAN</th>
                <th>Created date</th>
                <th>Modified Date</th>
                <th style={{ padding: '12px 16px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    height: '100%'
                  }}>
                    <span>Action</span>
                    <Checkbox
                      checked={selectAllCheck}
                      disabled={entireAllCheck}
                      onChange={() => {
                        selectAllItems();
                        setSelectAllCheck(!selectAllCheck);
                      }}
                      title={!selectAllCheck ? 'Select All' : 'Deselect All'}
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {mdmType === 'CUSTOMER' ? (
                <>
                  {triggerTable === true && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        Loading Please Wait!
                      </td>
                    </tr>
                  )}
                  {tableForRadio?.length > 0 &&
                    tableForRadio.map((values, i) => (
                      <tr key={i}>
                        <td>{values?.cust_legal_name}</td>
                        <td>{values?.cust_gstin}</td>
                        <td>{values?.cust_pan}</td>
                        <td>{values?.create_date}</td>
                        <td>{values?.modify_date}</td>
                        <td>
                          <Checkbox
                            checked={isChecked(values.unique_key)}
                            disabled={entireAllCheck}
                            onChange={(e) => tableCheckBox(e, values.unique_key)}
                          />
                        </td>
                      </tr>
                    ))}
                  {tableForRadio?.length === 0 && !triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </>
              ) : (
                <>
                  {triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center' }}>
                        Loading Please Wait!
                      </td>
                    </tr>
                  )}
                  {tableForRadio?.length > 0 &&
                    tableForRadio.map((values, i) => (
                      <tr key={i}>
                        <td>{values?.vendor_name}</td>
                        <td>{values?.vendor_gstin}</td>
                        <td>{values?.vendor_pan}</td>
                        <td>{values?.create_date}</td>
                        <td>{values?.modify_date}</td>
                        <td>
                          <Checkbox
                            checked={isChecked(values.unique_key)}
                            disabled={entireAllCheck}
                            onChange={(e) => tableCheckBox(e, values.unique_key)}
                          />
                        </td>
                      </tr>
                    ))}
                  {tableForRadio?.length === 0 && !triggerTable && (
                    <tr>
                      <td colSpan={6} style={{ textAlign: 'center', color: 'red' }}>
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <TablePagination
          rowsPerPageOptions={[25, 100, 500, 1000]}
          component="div"
          count={rowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </BoxWrapper>

      {/* form */}

      <BoxWrapper boxTitle="Filter">
        <div className="mdm-form">
          {mdmDataLoading ? (
            <div style={{
              padding: '40px 20px',
              textAlign: 'center',
              color: '#666'
            }}>
              <p style={{ margin: 0, fontSize: '14px' }}>
                Loading filters...
              </p>
            </div>
          ) : areAllFiltersDisabled() ? (
            <div style={{
              padding: '20px',
              textAlign: 'center',
              color: '#666',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px'
            }}>
              <p style={{ margin: 0, fontSize: '14px', justifyContent: 'center', textAlign: 'center' }}>
                No filters available. Please contact system admin.
              </p>
            </div>
          ) : (
            <>
              {getAvailableFilters().map((filter) => (
                <div key={filter.value}>
                  <Checkbox
                    checked={mutiSelector.includes(filter.value)}
                    onChange={(e) => handleChange(e, filter.value)}
                  />{" "}
                  <label>{filter.label}</label>
                </div>
              ))}

              <div>
                <button
                  className="button-outlined-primary"
                  onClick={mdmFormSubmitHandler}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </BoxWrapper>

      {/* <BoxWrapper boxTitle="Filter">
        <div className="mdm-form">
          {areAllFiltersDisabled() ? (
            <div style={{ 
              padding: '20px', 
              textAlign: 'center', 
              color: '#666',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px'
            }}>
              <p style={{ margin: 0, fontSize: '14px', justifyContent:'center', textAlign: 'center' }}>
                No filters available. Please configure MDM filters in the service settings.
              </p>
            </div>
          ) : (
            <>
              {getAvailableFilters().map((filter) => (
                <div key={filter.value}>
                  <Checkbox
                    checked={mutiSelector.includes(filter.value)}
                    onChange={(e) => handleChange(e, filter.value)}
                  />{" "}
                  <label>{filter.label}</label>
                </div>
              ))}

              <div>
                <button
                  className="button-outlined-primary"
                  onClick={mdmFormSubmitHandler}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </BoxWrapper> */}

      {/* history table */}
      <BoxWrapper
        boxTitle="MDM History"
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApi}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>MDM Type</th>
                <th>Created date & time</th>
                <th>Status</th>
                <th>Download</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.length > 0 &&
                tableData?.map((item, i) => {
                  return (
                    <tr key={`${i}mdm`}>
                      <td>{item?.cust_type}</td>
                      <td>
                        {moment(item?.initiated_time).format(
                          "DD/MM/YYYY, h:mm:ss a"
                        )}
                      </td>
                      <td>{item?.status}</td>
                      <td>
                        {item?.status === "Pass" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            onClick={() =>
                              downloadMDMHandler(item?.id, item?.cust_type)
                            }
                          />
                        ) : item?.status === "Fail" ? (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "red" }}
                            onClick={() =>
                              downloadMDMHandler(item?.id, item?.cust_type)
                            }
                          />
                        ) : (
                          <DownloadIcon
                            className="action-icon-button showIcon"
                            style={{ color: "#ddd" }}
                          />
                        )}
                      </td>
                    </tr>
                  );
                })}
              {tableData?.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center", color: "red" }}>
                    No Data Found!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>
    </>
  );
};

export default Mdm;